import { Configuration } from '../models/calculator';

export const fetchDataCalculator = async (
	urlOrigin: string,
	urlPath: string,
	marketingCode: string,
	apiKey: string,
): Promise<Configuration> => {
	const endpoint = `${urlOrigin}${urlPath}/okapi/marketing-code?marketingCode=${marketingCode}`;

	try {
		const response = await fetch(endpoint, {
			method: 'GET',
			headers: {
				'X-Api-Key': apiKey,
				'Content-Type': 'application/json',
			},
		});

		if (!response.ok) {
			throw new Error(`Error en la configuracion: ${response.status}`);
		}

		const data = (await response.json()) as Configuration;
		return data;
	} catch (error) {
		console.error('Error al cargar las configuraciones:', error);
		throw error;
	}
};
